class HHVariantPicker extends HTMLElement {
  constructor() {
    super()
    this.onCartUpdated = this.onCartUpdated.bind(this)
    this.currentVariant = null
  }

  connectedCallback() {
    if (this.dataset.selectedVariant) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return variant.id == this.dataset.selectedVariant
      })
    }
    this.addEventListener('change', this.onVariantChange)
    this.initDisabledVariants()
    this.getProductData()
    document.addEventListener('cart:updated', this.onCartUpdated)
  }

  disconnnectedCallback() {
    this.removeEventListener('change', this.onVariantChange)
    document.removeEventListener('cart:updated', this.onCartUpdated)
  }

  async getCartData() {
    try {
      let response = await fetch('/cart.js')
      if (response.ok) {
        this.cart = await response.json()
        return this.cart
      }
    } catch (error) {
      console.error('Error fetching cart:', error)
    }
  }

  getProductData() {
    this.product = JSON.parse(
      document.querySelector('[data-product-data]')?.textContent || '{}'
    )
  }

  initDisabledVariants() {
    this.getVariantData().forEach((variant) => {
      if (!variant.available) {
        document
          .querySelector(
            `.js-variant-label[data-option-value='${variant.title}']`
          )
          ?.classList.add('c-subdued')
      } else {
        document
          .querySelector(
            `.js-variant-label[data-option-value='${variant.title}']`
          )
          ?.classList.add('bold')
      }
    })
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
      this.getCartData().then(() => {
        this.validateQuantity()
        this.triggerSizekick()
      })
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    if (fieldsets && fieldsets.length) {
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find(
          (radio) => radio.checked
        ).value
      })
    } else {
      this.options = Array.from(
        this.querySelectorAll('select'),
        (select) => select.value
      )
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
    this.setAttribute('data-selected-variant', this.currentVariant.id)
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    )
    if (!newMedia) return
    const parent = newMedia.parentElement
    parent.prepend(newMedia)
    window.setTimeout(() => {
      parent.scroll(0, 0)
    })
  }

  updateURL() {
    if (!this.currentVariant) return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }
  validateQuantity() {
    let check_against_inventory = true
    let quantity_rule_soldout = false
    this.qtyMessageContrainer = document.querySelector('.quantity-rule-soldout')

    const cartQuantity =
      this.cart?.items.find(
        (item) => item.variant_id === this.currentVariant.id
      )?.quantity || 0

    const inventoryQuantity = this.currentVariant.inventory_quantity
    if (
      this.currentVariant.inventory_management != 'shopify' ||
      this.currentVariant.inventory_policy == 'continue'
    ) {
      check_against_inventory = false
    }
    if (
      this.currentVariant.quantity_rule.min + cartQuantity >
        inventoryQuantity &&
      check_against_inventory
    ) {
      quantity_rule_soldout = true
    }

    if (quantity_rule_soldout || !this.currentVariant.available) {
      this.toggleAddButton(
        true,
        this.currentVariant.available
          ? window.variantStrings.addToCart
          : window.variantStrings.soldOut,
        false,
        !this.currentVariant.available
      )

      if (this.currentVariant.available) {
        this.qtyMessageContrainer?.classList.add('block')
        this.qtyMessageContrainer?.classList.remove('hidden')
      } else {
        this.qtyMessageContrainer?.classList.add('hidden')
        this.qtyMessageContrainer?.classList.remove('block')
      }
    } else {
      this.qtyMessageContrainer?.classList.add('hidden')
      this.qtyMessageContrainer?.classList.remove('block')
      this.toggleAddButton(!this.currentVariant.available)
    }
  }

  async onCartUpdated() {
    if (this.currentVariant) {
      this.getCartData().then(() => {
        this.validateQuantity()
      })
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id)
        const source = html.getElementById(id)

        if (source && destination) destination.innerHTML = source.innerHTML

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove('visibility-hidden')
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true, hideOnOOS = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')

    const atcText = this.dataset.preOrder
      ? window.variantStrings.preOrder
      : this.dataset.finalSale
      ? window.variantStrings.addToCartFinalSale
      : window.variantStrings.addToCart

    if (!addButton) return

    if (disable) {
      addButton.setAttribute('disabled', true)
      addButton.setAttribute('style', 'display: none;')
      if (text) addButton.textContent = text
    } else {
      addButton.removeAttribute('disabled')
      addButton.removeAttribute('style')
      addButton.textContent = atcText
    }

    if (!hideOnOOS) addButton.removeAttribute('style')

    if (!modifyClass) return
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')
    if (!addButton) return
    addButton.textContent = window.variantStrings.unavailable
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add('visibility-hidden')
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }

  async triggerSizekick() {
    this.sizekickTrigger = document.querySelector('hh-sizekick-trigger')
    if (!this.product || !this.sizekickTrigger || !this.cart) return

    const cartItems = this.cart?.items.filter(
      (item) => item.product_id === this.product?.id
    )
    const sizePosition = this.product.options.find(
      (option) => option.name === 'Size' || option.name === 'size'
    )?.position
    // check if cart has similar item but different size
    const similarItem = cartItems.find((item) => {
      return item.options_with_values.some((option) => {
        return (
          option.value !== this.currentVariant[`option${sizePosition}`]?.value
        )
      })
    })
    if (similarItem) {
      this.sizekickTrigger?.showTooltip()
    }
  }
}

customElements.define('hh-variant-picker', HHVariantPicker)
